import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const InformationIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" strokeWidth="1.5" {...props}>
            <path d="M10 15.71L10 8.70996" stroke="currentColor" strokeWidth="inherit" strokeLinecap="round" />
            <path d="M10 4.01001L10 4.00001" stroke="currentColor" strokeWidth="inherit" strokeLinecap="round" />
        </SvgIcon>
    );
};
